import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(localeData);

export const checkNullinDate = (value, name) => {
  if (!value) return { [name]: undefined };
  return { [name]: dayjs(value) };
};

export const checkDatesIsOutsideRange = (
  dateFromValue,
  dateToValue,
  limitDays,
) => {
  if (!dateFromValue || !dateToValue) return false;
  const dateFrom = dayjs(dateFromValue);
  const dateTo = dayjs(dateToValue);
  return dateTo.diff(dateFrom, 'days') > limitDays;
};

export const valueToDateTime = date =>
  date && dayjs(date).format('YYYY-MM-DD HH:mm:ss');

export const valueToDateTimeNoSec = date =>
  date && dayjs(date).format('YYYY-MM-DD HH:mm');

export const valueToDate = date => date && dayjs(date).format('DD/MM/YYYY');

export const valueToDateSend = date => date && dayjs(date).format('YYYY-MM-DD');

export const endOfDay = () => dayjs().endOf('day');

export const startOfDay = () => dayjs().startOf('day');

export const setUpLocale = locale => dayjs.locale(locale?.toLowerCase());

export const rangePickerDisabled = date => dayjs(date) > dayjs();
